import { openNotification } from "../../../Components/Notification";
import { ZOHO_RECRUIT_OAUTH_SCOPE, ZOHO_RECRUIT_OAUTH_SERVER } from "../../../Utils/app-integration-constants";
import { generateSecureState } from "../../../Utils/generic-functions";

const ZOHO_CONFIG = {
  client_id: process.env.REACT_APP_ZOHO_RECRUIT_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_ZOHO_RECRUIT_OAUTH_CALLBACK_REDIRECT_URI,
  scope: ZOHO_RECRUIT_OAUTH_SCOPE,
  access_type: "offline",
  prompt: "consent",
  accounts_server: ZOHO_RECRUIT_OAUTH_SERVER,
};

export const useZohoRecruitConnect = () => {

  const handleZohoRecruitConnect = async (): Promise<void> => {
    try {
      if (!ZOHO_CONFIG.client_id) {
        console.error("Zoho Client ID not configured.");
        openNotification("error", "Zoho Recruit integration is not properly configured. Please contact support.", "");
        return;
      }

      if(!ZOHO_CONFIG.redirect_uri){
        console.error("Zoho Recruit Redirect URI not configured.");
        openNotification("error", "Zoho Recruit integration is not properly configured. Please contact support.", "");
        return;
      }

      const state = generateSecureState();
      sessionStorage.setItem("zoho_oauth_state", state);

      const authorizationUrl = new URL(
        `${ZOHO_CONFIG.accounts_server}/oauth/v2/auth`
      );

      const params = {
        response_type: "code",
        client_id: ZOHO_CONFIG.client_id,
        scope: ZOHO_CONFIG.scope,
        redirect_uri: ZOHO_CONFIG.redirect_uri,
        access_type: ZOHO_CONFIG.access_type,
        prompt: ZOHO_CONFIG.prompt,
        state: state,
      };

      Object.entries(params).forEach(([key, value]) => {
        authorizationUrl.searchParams.append(key, value);
      });

      window.location.href = authorizationUrl.toString();
    } catch (err) {
      console.error("Error while connecting to Zoho Recruit:", err);
      openNotification(
        "error",
        "Error while connecting to Zoho Recruit.",
        "Try again"
      );
      return;
    }
  };

  return {
    handleZohoRecruitConnect,
  };
};
